module.exports = __webpack_public_path__ + "img/logo_ic.5673a807.svg";